/**
* Operational status of a machine.
*             The machine acts like a finite automaton with the states defined here.
*/
export enum OpState { 
	/** It is currently not possible to establish a connection to the machine. */
	Offline = "Offline", 
	/**
	* The machine is initializing itself, e.g. while it is starting or heating.
	*             The screen should show a "Please wait..." message.
	*/
	Initializing = "Initializing", 
	/**
	* The machine is cleaning itself or preparing to clean itself
	*             (internal countdown for cleaning). A warning message must be shown
	*             on the screen, e.g. "Cleaning... Caution! Hot water!".
	*/
	Cleaning = "Cleaning", 
	/** The machine is online and ready to serve products. */
	Ready = "Ready", 
	/**
	* The machine is currently serving an order with one or multiple products.
	*             The screen should show a "Product serving..." message.
	*             See the current <see cref="T:Iovent.Machine.Status.ServingStatus" /> for more details.
	*/
	Serving = "Serving", 
	/**
	* The machine has successfully served a product, but the modules
	*             are not ready yet to start another product. As soon as this is possible,
	*             the machine goes into the <see cref="F:Iovent.Machine.Status.OpState.Ready" /> state. This state may be
	*             omitted, and the machine could switch back to <see cref="F:Iovent.Machine.Status.OpState.Ready" /> immediately.
	*/
	Served = "Served", 
	/**
	* The machine has failed serving a product. It will stay in this state at
	*             least a defined number of seconds. When the state of the machine requires intervention,
	*             it will switch into the <see cref="F:Iovent.Machine.Status.OpState.Intervention" /> state. Otherwise, when all modules
	*             are ready again, it will switch into the <see cref="F:Iovent.Machine.Status.OpState.Ready" /> state.
	*/
	Failed = "Failed", 
	/**
	* The machine can not serve products right now, because something has to be
	*             fixed, maybe by the service staff (e.g. refill coffee beans in a coffee machine).
	*             The screen should show a message like "Please call service staff!" for example.
	*             The controller tries to leave this state automatically, if the machine
	*             status allows it.
	*/
	Intervention = "Intervention", 
	/**
	* The machine can not serve products right now, because a special maintenance mode is active,
	*             that allows technician or service staff to maintain the machine or refill the products.
	*/
	Maintenance = "Maintenance"
}
